import { INITIAL_STATE as pagingMakerInitialState } from 'reducersMakers/pagingMaker';

export const mountSelectorAt = path => {
  const pathParts = path.split('.');
  const pathPartsLength = pathParts.length;

  return selector => (rootState, ...args) => {
    let localState = rootState;

    for(let i = 0; i < pathPartsLength; i++) {
      localState = localState[pathParts[i]];
    }

    return selector(localState, ...args, rootState);
  };
};

export const getTextEditing = (textEditingState, maxChars = process.env.KOOTH_MAX_CHARS) => {
  const isCharsLimitExceeded = textEditingState.text.length > maxChars;

  return {
    ...textEditingState,
    isSubmitDisabled: textEditingState.isSubmitting || textEditingState.text.length == 0 || isCharsLimitExceeded,
    isCharsLimitExceeded
  };
};

export const getPaging = (pagingState, options = {}) => {
  if(options.threadId) {
    pagingState = pagingState.byThreadId[options.threadId];

    if(!pagingState) {
      return pagingMakerInitialState;
    }
  }

  if(options.queryString) {
    pagingState = pagingState.byQuery[options.queryString];

    if(!pagingState) {
      return pagingMakerInitialState;
    }
  }

  const { page, pagesCount } = pagingState;

  return {
    ...pagingState,
    isPrevActive: page > 1,
    isNextActive: page < pagesCount
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/utils/selectors.js
 **/